import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import isEqual from 'hs-lodash/isEqual';
import omit from 'hs-lodash/omit';
import { uniqueId } from 'UIComponents/utils/underscore';
export default class AssetFeature extends createImmutableObjectClass({
  headline: '',
  imageUrl: '',
  text: '',
  id: ''
}, {
  fromJSON: (_ref) => {
    let rest = Object.assign({}, _ref);
    return Object.assign({}, rest, {
      id: uniqueId('theme-feature-')
    });
  },
  toJSON: (_ref2) => {
    let rest = Object.assign({}, _ref2);
    return Object.assign({}, rest);
  }
}) {
  // 'id' is used as a unique key that persists as the record updates, for ListTransition
  equals(assetFeature) {
    return isEqual(omit(this, ['id']), omit(assetFeature, ['id']));
  }

}